<template>
    <div id="contactUsIconButtonsDiv">
        <div id="phoneButtonDiv" class="contactUs" @click="openPhoneInfo">
            <i class="fas fa-phone"></i>
            <span v-if="!inMobile"> 
                &nbsp;888-890-1116
            </span>
        </div>
        <!--<div id="scheduleAnApointmentDiv" class="contactUs" @click="openScheduling">
            <img id="letUsFindItBullsEyeIcon" src="@/assets/LetUsFindItBullsEyeDartIcon.png"/>
            <span v-if="!inMobile"> 
                &nbsp;LET US FIND IT
            </span>
        </div>-->
    </div>
</template>

<script>
    export default  {
        computed: {
            inMobile() {
                return this.$store.getters.isMobile;
            }
        },
        methods: {
            openPhoneInfo() {
                if(this.$store.getters.isMobile) {
                    this.$gtag.event('call', {'event_category': 'contactUs'});
                }
                    document.location.href = "tel:+1888-890-1116";
            },
            /*openScheduling() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('appointment', {'event_category': 'contactUs','event_label': eventLabel});
                this.$store.dispatch('openAppInSeperateWindow', 'https://www.online.cars/schedule/');
            }*/
        }
    }
</script>

<style>
    #contactUsIconButtonsDiv {
        height: calc(12 * var(--vh));
        width: calc(15 * var(--vw));
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        color: white;
    }

    .contactUs {
        margin: calc(1 * var(--vh));
    }

    .inmobile #contactUsIconButtonsDiv {
        position: fixed;
        justify-content: space-around;
        right: 0;
        top: 0;
    }

    #scheduleAnApointmentDiv:hover {
        cursor: pointer;
        color: var(--mccluskeyGold); /*#AF873F;*/
    }
    
    .inmobile #phoneButton:hover {
        cursor: pointer;
        color: var(--mccluskeyGold); /*#AF873F;*/
    }

    #letUsFindItBullsEyeIcon {
        height: calc(2.4 * var(--vh));
    }

    #scheduleAnApointmentDiv {
        color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*/
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>